import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteJiraCredentials } from '@api';
import { getJiraSummarySlice } from './summary/get';

export const deleteJiraCredentialsSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ getJiraSummarySlice.asyncActionCreators.requestGetJiraSummary ]
	},
	name: 'jiraCredentials',
	receive: false,
	request: true,
	requestHandler: deleteJiraCredentials
});
